import { Controller } from "@hotwired/stimulus"
import { track as trackEvent } from "../lib/mixpanel"

// Phase 2.10 Tier 4 — Folder watch toggle. Mounted on folder headers
// (Documents folder, Drawing Set, Spec Set, Closeout Tab) by the
// `shared/_folder_watch_button.html.erb` partial. Same toggle endpoint
// as the kebab's per-document watch — `target_type` is one of
// `DocumentWatch::FOLDER_KINDS`.
export default class extends Controller {
  static targets = ["label", "iconSlot"]
  static values = {
    targetType: String,
    targetId: Number,
    watchUrl: String,
    watched: Boolean,
  }

  async toggle(event) {
    if (event) event.preventDefault()
    const wantWatched = !this.watchedValue
    const method = wantWatched ? "POST" : "DELETE"
    const body = new FormData()
    body.append("target_type", this.targetTypeValue)
    body.append("target_id", String(this.targetIdValue))

    try {
      const resp = await fetch(this.watchUrlValue, {
        method,
        headers: { "X-CSRF-Token": this._csrfToken(), "Accept": "application/json" },
        body,
      })
      const json = await resp.json().catch(() => ({}))
      if (!resp.ok || json.ok === false) {
        const message = json.error === "watch_disabled"
          ? "Watch is disabled for your company."
          : (json.message || "Could not update watch.")
        this._toast(message, "alert")
        return
      }

      this.watchedValue = !!json.watched
      this._renderState()

      trackEvent(wantWatched ? "Document Watched" : "Document Unwatched", {
        target_type: this.targetTypeValue,
        target_id: this.targetIdValue,
        folder: true,
      })
      this._toast(wantWatched ? "Watching folder." : "Stopped watching folder.", "notice")
    } catch (e) {
      this._toast(`Network error: ${e.message}`, "alert")
    }
  }

  _renderState() {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.watchedValue ? "Watching folder" : "Watch folder"
    }
    if (this.hasIconSlotTarget) {
      const svg = this.iconSlotTarget.querySelector("svg")
      if (svg) {
        if (this.watchedValue) {
          svg.classList.remove("text-gray-500")
          svg.classList.add("text-amber-500")
          svg.setAttribute("fill", "currentColor")
        } else {
          svg.classList.remove("text-amber-500")
          svg.classList.add("text-gray-500")
          svg.setAttribute("fill", "none")
        }
      }
    }
  }

  _csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.content : ""
  }

  _toast(message, type = "notice") {
    const el = document.createElement("div")
    el.className =
      type === "alert"
        ? "flash-toast-alert"
        : "flash-toast-notice"
    el.textContent = message
    el.dataset.controller = "flash"
    el.dataset.flashDismissAfterValue = "5000"
    document.body.prepend(el)
  }
}
